import { KEY_REDUCER_SHARE } from "./constants";

export const selectorShareData = (state) => state[KEY_REDUCER_SHARE].shareData;
